import React, { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import * as Yup from "yup"
import { SlClose } from "react-icons/sl"

import { useFormik } from "formik"
import { Alert, Modal } from "react-bootstrap"
import { Label, FormFeedback, Input, Form, Col, Row } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import { fetchMyProfileData } from "../../features/FetchData.jsx"

import PageBanner from "../../layouts/PageBanner.jsx"
import bg from "../../assets/images/banner/bnr4.jpg"

import { TempBookingCreate, Reset } from "../../features/Event/BookingSlice.jsx"
import TicketBookingButton from "../../components/Paypal/TicketBookingButton.jsx.jsx"
import {
  fetchSelectedVenue,
  FindRemainingAllTickets,
  FindRemainingFoodTickets,
  FindRemainingTickets,
} from "../../features/Event/EventTBSlice.jsx"
import { fetchMywallet } from "../../features/FetchData.jsx"
import _ from "lodash"

import moment from "moment"

const EventBooking = () => {

  const dispatch = useDispatch()


  const User_Id_ = JSON.parse(localStorage.getItem("user_id"))
  const userInfo = JSON.parse(localStorage.getItem("userInfo"))
  const selectedEvent = JSON.parse(localStorage.getItem("SelectVenue"))


  const { MyProfileInfo } = useSelector((state) => state.FetchDataReducer)

  const { TempBookindDetails, TempBookingFail, TempBookingSuccess } = useSelector((state) => state.BookingReducer)
  const { SelectedVenueData, Ticketperuser ,FoodTicketperuser,AllTicketperuser} = useSelector((state) => state.EventTBReducer)
const remainingFoodTickets = FoodTicketperuser?.remaining_food_tickets ?? 6;

  const [PaypalModal, setPaypalModal] = useState(false)
  const [bookingType, setBookingType] = useState(null)
  const [isBookingOpen, setBookingOpen] = useState(null)

  const [dataloading, setDataLoading] = useState(true)

  const maxTicketPerPerson = 6
  const [availableSeats, setAvaialbleSeats] = useState(6)
  const [totalTickets, setTotalTickets] = useState(0)

  const [adultCount, setAdultCount] = useState(0);
  const [childCount, setChildCount] = useState(0);
  const [adultTotalTicketPrice, setATTP] = useState(0);
  const [childTotalTicketPrice, setCTTP] = useState(0);
  const [totalTicketPrice, setTTP] = useState(0);

  const EVENT_TYPE_MAP = {
  ET001: "FOOD",
  ET002: "EVENT",
  ET003: "EVENT_WITH_FOOD",
};
 
const [vegCount, setVegCount] = useState(0);
const [nonVegCount, setNonVegCount] = useState(0);

const [adultTotal, setAdultTotal] = useState(0);
const [childTotal, setChildTotal] = useState(0);
const [vegTotal, setVegTotal] = useState(0);
const [nonVegTotal, setNonVegTotal] = useState(0);
 
// const eventType = SelectedVenueData?.event?.[0]?.eventType;
// const foodType = SelectedVenueData?.event?.[0]?.foodType;

// const showVeg = eventType === "FOOD" || eventType === "EVENTWITHFOOD"
//   ? foodType === "VEG" || foodType === "BOTH"
//   : false;
// const showNonVeg = eventType === "FOOD" || eventType === "EVENTWITHFOOD"
//   ? foodType === "NONVEG" || foodType === "BOTH"
//   : false;

const ET_FOOD = "ET001";
const ET_EVENT = "ET002";
const ET_EVENT_WITH_FOOD = "ET003";

 const FT_VEG = "FT001";
const FT_NONVEG = "FT002";
const FT_BOTH = "FT003";

const eventTypeId = SelectedVenueData?.event?.[0]?.eventTypeId;
const foodTypeId = SelectedVenueData?.event?.[0]?.foodTypeId;
console.log(`eventtypeid ----${eventTypeId}---${foodTypeId}`)

const showVeg = eventTypeId === ET_FOOD || eventTypeId === ET_EVENT_WITH_FOOD
  ? foodTypeId === FT_VEG || foodTypeId === FT_BOTH
  : false;
const showNonVeg = eventTypeId === ET_FOOD || eventTypeId === ET_EVENT_WITH_FOOD
  ? foodTypeId === FT_NONVEG || foodTypeId === FT_BOTH
  : false;
  

  const [errormsg, setErrormsg] = useState("")

  const [ticketBookingInfo, setTicketBookingInfo] = useState(null)

  useEffect(() => {
    console.log("am in", selectedEvent)
    //const selectedEvent = JSON.parse(localStorage.getItem("SelectVenue"))
    dispatch(fetchSelectedVenue(selectedEvent))
  }, [])

  useEffect(() => {
    console.log("SelectedVenueData", SelectedVenueData)
    setDataLoading(true)
    if (SelectedVenueData) {
      var earlyBirdIndex = _.findIndex(SelectedVenueData.ticket_allocations, { "booking_type": "early bird" })
      if (earlyBirdIndex !== -1) {
        setBookingType(SelectedVenueData.ticket_allocations[earlyBirdIndex])
        var startDate = moment.parseZone(SelectedVenueData.ticket_allocations[earlyBirdIndex].start_date).format("YYYY-MM-DD")
        var endDate = moment.parseZone(SelectedVenueData.ticket_allocations[earlyBirdIndex].end_date).format("YYYY-MM-DD")
        var date = new Date()
        var isBookingOpen = moment(date).isBetween(startDate, endDate, 'day', '[)')

        setBookingOpen(isBookingOpen)
        if (!isBookingOpen) {
          setBookingType(SelectedVenueData.ticket_allocations[SelectedVenueData.ticket_allocations.length - 1])
          var startDate = moment.parseZone(SelectedVenueData.ticket_allocations[SelectedVenueData.ticket_allocations.length - 1].start_date).format("YYYY-MM-DD")
          var endDate = moment.parseZone(SelectedVenueData.ticket_allocations[SelectedVenueData.ticket_allocations.length - 1].end_date).format("YYYY-MM-DD")
          var date = new Date()
          isBookingOpen = moment(date).isBetween(startDate, endDate, 'day', '[)')
          setBookingOpen(isBookingOpen)
        }
        setDataLoading(false)
      }
      else {
        setBookingType(SelectedVenueData.ticket_allocations[0])
        var startDate = moment.parseZone(SelectedVenueData.ticket_allocations[0].start_date).format("YYYY-MM-DD")
        var endDate = moment.parseZone(SelectedVenueData.ticket_allocations[0].end_date).format("YYYY-MM-DD")
        var date = new Date()
        var isBookingOpen = moment(date).isBetween(startDate, endDate, 'day', '[)')
        setBookingOpen(isBookingOpen)
        setDataLoading(false)

      }
    }
    else {
      //setDataLoading(false)
      //dispatch(fetchSelectedVenue(selectedEvent))
      
    }
  }, [SelectedVenueData])

  

  useEffect(() => {
  if (!SelectedVenueData?._id || !userInfo?._id) return;

  const payload = {
    memberID: userInfo._id,
    master_venue_id: SelectedVenueData._id,
  };

  dispatch(FindRemainingTickets(payload));
  dispatch(FindRemainingFoodTickets(payload));
  dispatch(FindRemainingAllTickets(payload));

}, [dispatch, SelectedVenueData?._id, userInfo?._id, TempBookingSuccess]);
useEffect(() => {
  if (!SelectedVenueData || !userInfo) return;

  const eventTypeId = SelectedVenueData?.event[0]?.eventTypeId;

  if (eventTypeId === ET_EVENT) {
    dispatch(FindRemainingTickets({
      memberID: userInfo._id,
      master_venue_id: SelectedVenueData._id,
    }));
  } else if (eventTypeId === ET_FOOD) {
    dispatch(FindRemainingFoodTickets({
      memberID: userInfo._id,
      master_venue_id: SelectedVenueData._id,
    }));
  } else if (eventTypeId === ET_EVENT_WITH_FOOD) {
    dispatch(FindRemainingAllTickets({
      memberID: userInfo._id,
      master_venue_id: SelectedVenueData._id,
    }));
  }
}, [SelectedVenueData?._id, userInfo?._id]);

// place this in your component (replace any previous useEffect that sets availableSeats)
useEffect(() => {
  if (!SelectedVenueData) return;

  const eventTypeId = SelectedVenueData?.event?.[0]?.eventTypeId;
  const maxPerPerson = maxTicketPerPerson || 6;

  // normalize backend responses (safest checks for different shapes)
  const personRemaining =
    Ticketperuser?.remaining_tickets ??
    AllTicketperuser?.remaining_person_tickets ??
    null;

  const foodRemaining =
    FoodTicketperuser?.remaining_food_tickets ??
    AllTicketperuser?.remaining_food_tickets ??
    null;

  let remaining = maxPerPerson; // default fallback

  if (eventTypeId === ET_EVENT) {
    // use remaining person tickets if available, otherwise fallback
    remaining = typeof personRemaining === "number" ? personRemaining : maxPerPerson;
  } else if (eventTypeId === ET_FOOD) {
    // use remaining food tickets
    remaining = typeof foodRemaining === "number" ? foodRemaining : maxPerPerson;
  } else if (eventTypeId === ET_EVENT_WITH_FOOD) {
    // combined: make sure to respect both limits (choose the tighter)
    const p = typeof personRemaining === "number" ? personRemaining : maxPerPerson;
    const f = typeof foodRemaining === "number" ? foodRemaining : maxPerPerson;
    remaining = Math.min(p, f);
  }

  // never negative, never exceed maxPerPerson
  const finalRemaining = Math.max(0, Math.min(remaining, maxPerPerson));
  console.log("SET availableSeats =>", { eventTypeId, personRemaining, foodRemaining, finalRemaining });
  setAvaialbleSeats(finalRemaining);
}, [SelectedVenueData, Ticketperuser, FoodTicketperuser, AllTicketperuser, maxTicketPerPerson]);

// const handleAdultCountChange = (e) => {
//     e.preventDefault()

//     const re = /^[0-6\b]+$/

//     // console.log("re.test(e.target.value)", re.test(e.target.value))

//     if (e.target.value === "" || re.test(e.target.value)) {
//       var value = String(e.target.value).charAt(
//         String(e.target.value).length - 1
//       )

//       const newCount = Number(e.target.value)
//       var getCount = newCount + Number(childCount)

//       if (getCount > availableSeats) {
//         setErrormsg(
//           `Maximum number of tickets allowed for booking 6 per person ${User_Id_ ? `and you have remaining ${availableSeats}` : ""
//           }. `
//         )
//         setAdultCount(0)
//       } else {
//         setErrormsg()
//         setAdultCount(value)
//       }
//     } else {
//       setErrormsg(`Not More than 6 allowed `)
//     }
//   }

//   const handleChildCountChange = (e) => {
//     e.preventDefault()
//     const re = /^[0-6\b]+$/

//     if (e.target.value === "" || re.test(e.target.value)) {
//       var value = String(e.target.value).charAt(
//         String(e.target.value).length - 1
//       )

//       const newCount = Number(e.target.value)
//       var getCount = newCount + Number(adultCount)

//       // console.log("am in", e.target.value, getCount)
//       // if (getCount > 6) {
//       if (getCount > availableSeats) {
//         setErrormsg(
//           `Maximum number of tickets allowed for booking 6 per person ${User_Id_ ? `and you have remaining ${availableSeats}` : ""
//           }. `
//         )
//         setChildCount(0)
//       } else {
//         setErrormsg()
//         setChildCount(value)
//       }
//     } else {
//       setErrormsg(`Not More than 6 allowed `)
//     }
//   }

const handleCountChange = (type, value) => {
  const newValue = Number(value);
  const eventTypeId = SelectedVenueData?.event[0]?.eventTypeId;

  // temporary local copies
  let adults = adultCount;
  let children = childCount;
  let vegs = vegCount;
  let nonvegs = nonVegCount;

  if (type === "adult") adults = newValue;
  if (type === "child") children = newValue;
  if (type === "veg") vegs = newValue;
  if (type === "nonveg") nonvegs = newValue;

  //  Calculate totals
  const totalPeople = adults + children;
  let totalFood = vegs + nonvegs;

  if (eventTypeId === ET_EVENT) {
    if (totalPeople > availableSeats) {
      setErrormsg(`You can book maximum ${availableSeats} tickets.`);
      return;
    }
  } else if (eventTypeId === ET_FOOD) {
    if (totalFood > availableSeats) {
      setErrormsg(`You can order maximum ${availableSeats} meals.`);
      return;
    }
  } 

  else if (eventTypeId === ET_EVENT_WITH_FOOD) {

  let totalPeopleCalc = adults + children;
  let totalFoodCalc = vegs + nonvegs;

  //  Prevent exceeding total seats
  if (totalPeopleCalc > availableSeats) {
    setErrormsg(`Maximum ${availableSeats} tickets allowed.`);
    return;
  }

  //  If veg/nonveg increased more than total people -> STOP & show error
  if ((type === "veg" || type === "nonveg") && totalFoodCalc > totalPeopleCalc) {
    setErrormsg(`Food count cannot exceed total persons (${totalPeopleCalc}).`);
    return;
  }

  //  Auto reduce food IF adult/child reduced
  if (totalFoodCalc > totalPeopleCalc) {
    let excess = totalFoodCalc - totalPeopleCalc;

    // Reduce nonveg first
    if (nonvegs >= excess) {
      nonvegs -= excess;
    } else {
      const remain = excess - nonvegs;
      nonvegs = 0;
      vegs = Math.max(0, vegs - remain);
    }

    totalFoodCalc = vegs + nonvegs;
  }

  // 4 Prevent food > available seats
  if (totalFoodCalc > availableSeats) {
    setErrormsg(`Food count cannot exceed available seats (${availableSeats}).`);
    return;
  }
}
  // else if (eventTypeId === ET_EVENT_WITH_FOOD) {
  //   // Prevent exceeding total seats
  //   if (totalPeople > availableSeats) {
  //     setErrormsg(`Maximum ${availableSeats} tickets allowed.`);
  //     return;
  //   }

  //   //  Auto-adjust food if people reduced
  //   if (totalFood > totalPeople) {
  //     const excess = totalFood - totalPeople;

  //     // Try to reduce nonveg first, then veg
  //     if (nonvegs >= excess) {
  //       nonvegs -= excess;
  //     } else {
  //       const remaining = excess - nonvegs;
  //       nonvegs = 0;
  //       vegs = Math.max(0, vegs - remaining);
  //     }

  //     totalFood = vegs + nonvegs;
  //   }

  //   // Prevent food > availableSeats
  //   if (totalFood > availableSeats) {
  //     setErrormsg(`Food count cannot exceed ${availableSeats}.`);
  //     return;
  //   }
  // }
 

  // ✅ Update states if valid
  setErrormsg("");
  setAdultCount(adults);
  setChildCount(children);
  setVegCount(vegs);
  setNonVegCount(nonvegs);
};
 

  useEffect(() => {
    if (SelectedVenueData && bookingType) {
      var total = adultCount + childCount
      var adtPrice = userInfo ? bookingType.adult_price : bookingType.n_adult_price
      var kdsPrice = userInfo ? bookingType.kids_price : bookingType.n_kids_price
      var adltTicketPrice = adultCount * Number(adtPrice)
      var chldTicketPrice = childCount * Number(kdsPrice)
      setATTP(adltTicketPrice)
      setCTTP(chldTicketPrice)
      setTotalTickets(total)
    }
  }, [adultCount, childCount, SelectedVenueData, bookingType])

  // useEffect(() => {
  //   var totalPrice = adultTotalTicketPrice + childTotalTicketPrice
  //   setTTP(totalPrice)
  // }, [adultTotalTicketPrice, childTotalTicketPrice])

  useEffect(() => {
  if (bookingType && SelectedVenueData) {
    const adtPrice = userInfo ? bookingType.adult_price : bookingType.n_adult_price;
    const chdPrice = userInfo ? bookingType.kids_price : bookingType.n_kids_price;
    const vegPrice = userInfo ? bookingType.veg_price : bookingType.nm_veg_price;
    const nonVegPrice = userInfo ? bookingType.nonveg_price : bookingType.nm_nonveg_price;

    setAdultTotal(adultCount * Number(adtPrice || 0));
    setChildTotal(childCount * Number(chdPrice || 0));
    setVegTotal(vegCount * Number(vegPrice || 0));
    setNonVegTotal(nonVegCount * Number(nonVegPrice || 0));

    setTTP(
      (adultCount * Number(adtPrice || 0)) +
      (childCount * Number(chdPrice || 0)) +
      (vegCount * Number(vegPrice || 0)) +
      (nonVegCount * Number(nonVegPrice || 0))
    );
  }
}, [adultCount, childCount, vegCount, nonVegCount, bookingType, SelectedVenueData]);


  const getAmountWithTax = (fielddata) => {

    let fees = (2.25 / 100) * Number(totalTicketPrice) + 0.31
    let Amountvalue = (Number(totalTicketPrice) + fees).toFixed(2)

    return Amountvalue
  }

  useEffect(() => {
    if (TempBookingSuccess) {
      validation.resetForm()
      setTicketBookingInfo(TempBookindDetails)
      setPaypalModal(true)
    }
    dispatch(Reset())
  }, [TempBookingSuccess, TempBookingFail])


  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      sats_member_id: userInfo?.member_id || "",
      memberID: userInfo?._id || null,
      master_event_id: SelectedVenueData?.master_event_id || "",
      master_venue_id: SelectedVenueData?._id || "",
      event_name: SelectedVenueData?.event[0].name || "",
      venue_name: SelectedVenueData?.venue || "",
      event_date: SelectedVenueData?.event[0].start_date || "",
      venue_date: SelectedVenueData?.start_datetime || "",
      email: userInfo?.email || "",
      firstname: userInfo?.firstname || "",
      lastname: userInfo?.lastname || "",
      mobile: userInfo?.mobile || "",
      max_tickets: SelectedVenueData?.max_tickets || 0,
      remaining_tickets: SelectedVenueData?.remaining_tickets || 0,
      ticket_sold: SelectedVenueData?.ticket_sold || 0,
      adult_count: "",
      child_count: "",
      adult_amount: "",
      child_amount: "",
      net_amount: "",
      veg: "",
      nonveg: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email Id is required"),
      firstname: Yup.string().required("Enter your First Name"),
      lastname: Yup.string().required("Enter your Last Name"),

      mobile: Yup.string()
        .matches(
          /^[0-9+\-\(\) ]{8,20}$/,
          "Invalid phone number,Example :+91 7289789898 (Enter country code and Mobile number)"
        )
        .required("Mobile Number is required"),
    }),
 
    onSubmit: (values) => {
       const eventTypeId = SelectedVenueData?.event?.[0]?.eventTypeId;

  values["event_type"] = EVENT_TYPE_MAP[eventTypeId];
  
  values["adult_count"] = adultCount;
  values["child_count"] = childCount;
  values["veg_count"] = vegCount || 0;
  values["nonveg_count"] = nonVegCount || 0;
  values["adult_amount"] = adultTotal;
  values["child_amount"] = childTotal;
  values["veg_amount"] = vegTotal || 0;
  values["nonveg_amount"] = nonVegTotal || 0;
  // values["net_amount"] = getAmountWithTax();
  values["net_amount"] = totalTicketPrice
  

  const totalPeople = adultCount + childCount + vegCount + nonVegCount;
  if (totalPeople === 0) {
    setErrormsg("Please select at least one ticket/meal.");
    return;
  }

  dispatch(TempBookingCreate(values));
}

 
    
  })

  

 

  const handleKeyDownmobile = (event) => {
    // Allow numbers and special keys like Backspace, Delete, Arrow keys, etc.
    if (
      !/^[0-9()\s]*$/.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      event.key !== "ArrowLeft" &&
      event.key !== "ArrowRight"
    ) {
      event.preventDefault()
    }
  }
  const handleKeyDowncharcters = (event) => {
    // Allow numbers and special keys like Backspace, Delete, Arrow keys, etc.
    if (
      !/^[A-Za-z\s]*$/.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      event.key !== "ArrowLeft" &&
      event.key !== "ArrowRight"
    ) {
      event.preventDefault()
    }
  }




  if (!dataloading) {

    return (
      <div className="page-content bg-white">
        <PageBanner maintitle="Home" pagetitle="Booking" background={bg} />

        <div className="container mt-3">
          <div className="row">

            <div className="col-sm-12 col-lg-4">
              <div className="row">

                <div className="col-12 ">
                  <Link
                    to={"/UpComingEvent"}
                    className="fw-bold text-primary"
                    style={{ fontSize: 30 }}
                  >
                    {SelectedVenueData?.event[0].name}
                  </Link>
                </div>
                <div className="col-12 ">
                  <div>
                    <span
                      className="text-dark"
                      style={{ fontSize: 20, lineHeight: 0.5 }}
                    >
                      {SelectedVenueData.venue}
                    </span>
                  </div>

                  <div className="mb-3">
                    <span
                      className="text-dark"
                      style={{ fontSize: 16, lineHeight: 0.5 }}
                    >
                      {moment.parseZone(SelectedVenueData.start_datetime).format("LLLL")}
                    </span>
                  </div>
                </div>

                {
                  SelectedVenueData.organisers.length > 0 &&
                  <div
                    style={{ paddingTop: 5, marginBottom: 5 }}
                  >
                    {
                      SelectedVenueData.organisers?.map((item, ind) => (
                        <div className="col" key={ind}>
                          <p className="text-dark" style={{ lineHeight: 1.5 }}>
                            <span className="">{item.name}</span>

                            <br />
                            {item.contact_number}
                            <br />
                            {item.email_id}
                          </p>
                        </div>
                      ))}
                  </div>
                }

                <div className="col-12 ">
                  <span style={{ fontSize: 13, color: "0000ff" }}> Maximum {maxTicketPerPerson} tickets allowed per person </span>
                </div>

                {
                  isBookingOpen && bookingType.booking_type === "early bird" &&
                  <div className="col-12 ">
                    <span style={{ fontSize: 15, color: "#1f70f2", fontWeight: "700" }}>Early Bird Booking</span>
                  </div>
                }
                {
                  <div className="col-12 ">
                    <span style={{ fontSize: 13, fontWeight: "bold" }}>{userInfo ? "Member" : "Non-Member"}</span>
                  </div>
                }
                {/* {userInfo && availableSeats !== 0 &&
                  <div className="col-12 ">
                    <span style={{ fontSize: 12, color: "red", marginBottom: 15 }}>{availableSeats} Tickets available to book</span>
                  </div>
                } */}
{userInfo && availableSeats > 0 && (
  <div className="col-12">
    <span style={{ fontSize: 12, color: "red", marginBottom: 15 }}>
      {SelectedVenueData?.event?.[0]?.eventTypeId === ET_FOOD
        ? `${availableSeats} Meals available to order`
        : `${availableSeats} Tickets available to book`}
    </span>
  </div>
)}

                 

                 {isBookingOpen && availableSeats !== 0 &&
                  <div className="col">
                    <div>
                      <span
                        className="text-dark fw-bold"
                        style={{ fontSize: 20, lineHeight: 0.7 }}
                      >
                        Ticket Price
                      </span>
                    </div>
                     {console.log(`0000--${SelectedVenueData?.event[0].eventType}`)}
                     {/* event only */}
                    {(SelectedVenueData?.event[0].eventTypeId==ET_EVENT||SelectedVenueData?.event[0].eventTypeId==ET_EVENT_WITH_FOOD)&&(<div className="d-flex flex-row">
                      <div className="col-auto py-2 me-5">
                        <div>
                          <span
                            className="text-dark "
                            style={{ fontSize: 16, lineHeight: 1 }}
                          >
                           Adult:{" "}
                          </span>
                          <br />
                          <span
                            className="text-primary"
                            style={{ fontSize: 30, lineHeight: 1 }}
                          >{`$ ${!userInfo ? bookingType.n_adult_price : bookingType.adult_price}`}</span>
                        </div>
                      </div>
                      <div className="col-auto py-2">
                        <div>
                          <span
                            className="text-dark "
                            style={{ fontSize: 16, lineHeight: 1 }}
                          >
                            
                            Child:{" "}
                          </span>
                          <br />
                          <span
                            className="text-primary"
                            style={{ fontSize: 30, lineHeight: 1 }}
                          >{`$ ${!userInfo ? bookingType.n_kids_price : bookingType.kids_price}`}</span>
                        </div>
                      </div>
                    </div>)}
                    
                    {/* food only */}

                     {/* {(SelectedVenueData?.event[0].eventType=="FOOD"||SelectedVenueData?.event[0].eventType=="EVENTWITHFOOD")&&(<div className="d-flex flex-column">
                      <div className="col-auto py-2">
                        <div>
                           <span
                            className="text-dark fw-semibold d-block"
                            style={{
                              fontSize: 16,
                              lineHeight: 1.4,
                              whiteSpace: "pre-line",
                              minHeight: "40px",
                              textAlign: "start",
                            }}
                          >
                            {userInfo
            ? `Veg\n(Entry + Meal on \n Banana Leaf + Membership Sweet Box)`
            : `Veg\n(Entry + Meal on \n Banana Leaf)`}
                          </span>
                          <br />
                          <span
                            className="text-primary"
                            style={{ fontSize: 30, lineHeight: 1 }}
                          >{`$ ${!userInfo ? bookingType.nm_veg_price : bookingType.veg_price}`}</span>
                        </div>
                      </div>
                      <div className="col-auto py-2">
                        <div>
                          <span
                            className="text-dark fw-semibold d-block"
                            style={{
                              fontSize: 16,
                              lineHeight: 1.4,
                              whiteSpace: "pre-line",
                              minHeight: "40px",
                              textAlign: "start",
                            }}
                          >
                            
                             {userInfo
            ? `Non-Veg\n(Entry + Meal on\n Banana Leaf + Membership Sweet Box)`
            : `Non-Veg\n(Entry + Meal on \n Banana Leaf)`}
                          </span>
                          <br />
                          <span
                            className="text-primary"
                            style={{ fontSize: 30, lineHeight: 1 }}
                          >{`$ ${!userInfo ? bookingType.nm_nonveg_price : bookingType.nonveg_price}`}</span>
                        </div>
                      </div>
                    </div>)} */}
                    {(SelectedVenueData?.event[0].eventTypeId === ET_FOOD ||
  SelectedVenueData?.event[0].eventTypeId === ET_EVENT_WITH_FOOD) && (
  <div className="d-flex flex-column">
     {(SelectedVenueData?.event[0].foodTypeId === FT_VEG ||
      SelectedVenueData?.event[0].foodTypeId === FT_BOTH) && (
      <div className="col-auto py-2">
        <div>
          <span
            className="text-dark fw-semibold d-block"
            style={{
              fontSize: 16,
              lineHeight: 1.4,
              whiteSpace: "normal",
              minHeight: "40px",
              textAlign: "start",
            }}
          >
            {userInfo ? (
              <>
                Veg
                <br />
                {/* (Entry + Meal on Banana Leaf + Membership Sweet Box) */}
                {/* veg */}
                {SelectedVenueData?.event?.[0]?.short_veg_dec?.trim()
  ? ` (${SelectedVenueData.event[0].short_veg_dec.trim()})`
  : ""}
              </>
            ) : (
              <>
                Veg
                <br />
                {/* (Entry + Meal on Banana Leaf) */}
                 {SelectedVenueData?.event?.[0]?.short_veg_dec?.trim()
  ? ` (${SelectedVenueData.event[0].short_veg_dec.trim()})`
  : ""}
              </>
            )}
          </span>
           
          <span
            className="text-primary"
            style={{ fontSize: 30, lineHeight: 1 }}
          >
            {`$ ${
              !userInfo
                ? bookingType?.nm_veg_price || 0
                : bookingType?.veg_price || 0
            }`}
          </span>
        </div>
      </div>
    )}

     {(SelectedVenueData?.event[0].foodTypeId === FT_NONVEG ||
      SelectedVenueData?.event[0].foodTypeId === FT_BOTH) && (
      <div className="col-auto py-2">
        <div>
          <span
            className="text-dark fw-semibold d-block"
            style={{
              fontSize: 16,
              lineHeight: 1.4,
              whiteSpace: "normal",
              minHeight: "40px",
              textAlign: "start",
            }}
          >
             {userInfo ? (
              <>
                Non-Veg
                <br />
                {/* (Entry + Meal on Banana Leaf + Membership Sweet Box) */}
                 {SelectedVenueData?.event?.[0]?.short_nonveg_dec?.trim()
  ? ` (${SelectedVenueData.event[0].short_nonveg_dec.trim()})`
  : ""}
              </>
            ) : (
              <>
                Non-Veg
                <br />
                {/* (Entry + Meal on Banana Leaf) */}
                 {SelectedVenueData?.event?.[0]?.short_nonveg_dec?.trim()
  ? ` (${SelectedVenueData.event[0].short_nonveg_dec.trim()})`
  : ""}

  
              </>
            )}
          </span>
           
          <span
            className="text-primary"
            style={{ fontSize: 30, lineHeight: 1 }}
          >
            {`$ ${
              !userInfo
                ? bookingType?.nm_nonveg_price || 0
                : bookingType?.nonveg_price || 0
            }`}
          </span>
        </div>
      </div>
    )}
  </div>
)}

                  </div>
                }

              </div>

            </div>
            {
              availableSeats !== 0 &&
              <div className="col-sm-12 col-lg-8">

                <Form
                  onSubmit={(event) => {
                    event.preventDefault()
                    validation.handleSubmit()
                  }}
                >
                  <div className="row">
                    <small className="px-5 text-primary"></small>
                    <div className="row">
                      <div className="mb-3 col-12 col-lg-6 col-md-6">
                        <Label htmlFor="firstname">
                          First Name<span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="firstname"
                          className={`form-control`}
                          placeholder="Enter Your First Name"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.firstname || ""}
                          onKeyDown={handleKeyDowncharcters}
                          invalid={
                            validation.touched.firstname &&
                              validation.errors.firstname
                              ? true
                              : false
                          }
                        />
                        {validation.touched.firstname &&
                          validation.errors.firstname ? (
                          <FormFeedback
                            type="invalid"
                            style={{ fontSize: "12px" }}
                          >
                            {validation.errors.firstname}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-12 col-lg-6 col-md-6">
                        <Label htmlFor="lastname">
                          Last Name<span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="lastname"
                          className={`form-control`}
                          placeholder="Enter Your Last Name"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.lastname || ""}
                          onKeyDown={handleKeyDowncharcters}
                          invalid={
                            validation.touched.lastname &&
                              validation.errors.lastname
                              ? true
                              : false
                          }
                        />
                        {validation.touched.lastname &&
                          validation.errors.lastname ? (
                          <FormFeedback
                            type="invalid"
                            style={{ fontSize: "12px" }}
                          >
                            {validation.errors.lastname}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                    <div className="row">
                      <div className="mb-3 col-12 col-lg-6 col-md-6">
                        <Label htmlFor="email">
                          Email<span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="email"
                          className={`form-control`}
                          placeholder="Enter Your Email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email &&
                              validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email &&
                          validation.errors.email ? (
                          <FormFeedback
                            type="invalid"
                            style={{ fontSize: "12px" }}
                          >
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-12 col-lg-6 col-md-6">
                        <Label htmlFor="mobile">
                          Mobile Number
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="mobile"
                          type="tel"
                          min={4}
                          className="form-control "
                          placeholder="Enter Mobile Number"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.mobile || ""}
                          maxLength={20}
                          onKeyDown={handleKeyDownmobile}
                          invalid={
                            validation.touched.mobile &&
                              validation.errors.mobile
                              ? true
                              : false
                          }
                        />
                        {validation.touched.mobile &&
                          validation.errors.mobile ? (
                          <FormFeedback
                            type="invalid"
                            style={{ fontSize: "12px" }}
                          >
                            {validation.errors.mobile}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                    <p style={{ fontSize: "13px", color: "blue" }}>
                      {User_Id_ && Ticketperuser < 6
                        ? `'${Ticketperuser} tickets available for you'`
                        : ""}
                    </p>

                    
{/* allow maximum 6 ticket count  */}

  <div className="row">
  {(SelectedVenueData?.event[0].eventTypeId === ET_EVENT ||
    SelectedVenueData?.event[0].eventTypeId === ET_EVENT_WITH_FOOD) && (
    <>
      {/* Adult Input */}
      <div className="mb-3 col-sm-12 col-lg-2 col-md-2">
        <Label>
          Adult<span className="text-danger">*</span>
        </Label>
        <Input
          style={{ fontSize: 30 }}
          type="number"
          min={0}
          max={availableSeats}
          value={adultCount} 
          onChange={(e) => handleCountChange("adult", e.target.value)}
        />
      </div>

      {/* Child Input */}
      <div className="mb-3 col-sm-12 col-lg-2 col-md-2">
        <Label>
          Child<span className="text-danger">*</span>
        </Label>
        <Input
          style={{ fontSize: 30 }}
          type="number"
          min={0}
          max={availableSeats}
          value={childCount} 
          onChange={(e) => handleCountChange("child", e.target.value)}
        />
      </div>
    </>
  )} 

  {/* {(SelectedVenueData?.event[0].eventType === "FOOD" ||
  SelectedVenueData?.event[0].eventType === "EVENTWITHFOOD") && (
  <>
     <div className="mb-3 col-sm-12 col-lg-2 col-md-2">
      <Label>
        Veg<span className="text-danger">*</span>
      </Label>
      <Input
        style={{ fontSize: 30 }}
        type="number"
        min={0}
        max={6}
        value={vegCount} 
        onChange={(e) => handleCountChange("veg", e.target.value)}
      />
    </div>

     <div className="mb-3 col-sm-12 col-lg-2 col-md-2">
      <Label>
        Non-Veg<span className="text-danger">*</span>
      </Label>
      <Input
        style={{ fontSize: 30 }}
        type="number"
        min={0}
        max={6}
        value={nonVegCount} 
        onChange={(e) => handleCountChange("nonveg", e.target.value)}
      />
    </div>
  </>
)} */}

{(eventTypeId === ET_FOOD || eventTypeId === ET_EVENT_WITH_FOOD) && (
  <>
    {showVeg && (
      <div className="mb-3 col-sm-12 col-lg-2 col-md-2">
        <Label>
          Veg<span className="text-danger">*</span>
        </Label>
        <Input
          style={{ fontSize: 30 }}
          type="number"
          min={0}
          max={availableSeats}
          value={vegCount}
          onChange={(e) => handleCountChange("veg", e.target.value)}
        />
      </div>
    )}

    {showNonVeg && (
      <div className="mb-3 col-sm-12 col-lg-2 col-md-2">
        <Label>
          Non-Veg<span className="text-danger">*</span>
        </Label>
        <Input
          style={{ fontSize: 30 }}
          type="number"
          min={0}
          max={availableSeats}
          value={nonVegCount}
          onChange={(e) => handleCountChange("nonveg", e.target.value)}
        />
      </div>
    )}
  </>
)}

</div>
                    
                     
                    <p
                      className="text-danger text-justify "
                      style={{ fontSize: 12, lineHeight: 1 }}
                    >
                      {errormsg}
                    </p>

                    <div className="row align-items-center">
                      <div className="col-sm-12 col-lg-4 col-md-4">
                        <div className="d-flex flex-row">
                          <div className="col-auto py-2 me-5">
                            <div>
                              <span
                                className="text-dark"
                                style={{ fontSize: 20, lineHeight: 1 }}
                              >
                                Total Amount:{" "}
                              </span>

                              <br />
                              {/* <span
                                className="text-primary fw-bold"
                                style={{ fontSize: 30, lineHeight: 1 }}
                              >{`$ ${adultTotalTicketPrice > 0 || childTotalTicketPrice > 0 ? getAmountWithTax() : 0}`}</span> */}
                              <span
                              className="text-primary fw-bold"
                              style={{ fontSize: 30, lineHeight: 1 }}
                            >
                              {/* {`$ ${totalTicketPrice > 0 ? getAmountWithTax() : 0}`} */}
                                                            {`$ ${totalTicketPrice  }`}

                            </span>

                            </div>
                          </div>
                        </div>
                      </div>


                      <div className="col-sm-12 col-lg-4 col-md-4">
                        <button
                          type="submit"
                          className="btn btn-warning mx-3"
                          disabled={
                            errormsg ===
                            "Your count is empty fill it to continue"
                          }
                        >
                          {"Submit"}
                        </button>
                      </div>
                    </div>
                    {/* <div className="mb-3">
                      <span className="text-danger">*</span>{" "}
                      <small>
                        PayPal Transaction Fee (2.25%+31 Cents) Extra
                      </small>
                    </div> */}
                  </div>
                </Form>
              </div>

            }

          </div>
        </div>

        <Modal
          className="modal fade modal-wrapper auth-modal"
          show={PaypalModal}
          onHide={() => setPaypalModal(false)}
          centered
          backdrop="static"
        >
          <h2 className="title">
            Payment Process{" "}
            <span
              className="position-absolute top-0 start-100 translate-middle text-light  rounded-circle"
              style={{
                fontSize: "2rem",
                cursor: "pointer",
              }}
              onClick={() => {
                setPaypalModal(false)
              }}
            >
              <SlClose />
            </span>
          </h2>
          <Form
            onSubmit={(e) => {
              e.preventDefault()
              //ValidationRegister.handleSubmit()
            }}
          >
            <TicketBookingButton
              data2={ticketBookingInfo}
              setPaypalModal={setPaypalModal}
            />
            {/* <PaymentPaypal data2={validation.values} /> */}
          </Form>
        </Modal>




      </div>
    )
  }
  else {
    return null
  }
}

export default EventBooking